module.exports = __webpack_public_path__ + "static/media/messenger.53f1af37.svg";